'use strict';

const { h } = require('phy');
const { pruneData } = require('../../support/prune-data');
const { getRelatedTableClass } = require('../../support/category-helper');

const CouponUber = require('./coupon-uber');
const CouponTile = require('./coupon-tile');
const CategoryRelatedTable = require('../../category/views/category-related');
const EmailSubscription = require('../../email_subscription/views/email-subscription');

const AMOUNT_TO_PRELOAD = 4;
const AMOUNT_BEFORE_INLINE_CONTENT = 3;

function renderItem({ item, index, routes, media, isTouch }) {
  if (item.type === 'related') {
    return CategoryRelatedTable({
      className: item.className,
      parentCategory: item.parentCategory,
      categories: item.categories,
      merchants: item.merchants,
      routes,
      isTouch,
    });
  }

  if (item.type === 'email') {
    const { merchantSlug, csrfToken, emailCTAExperiment } = item;

    return EmailSubscription({
      display: emailCTAExperiment.treatment,
      csrfToken,
      routes,
      classNames: {
        inner: 'email-subscription-full-width.email-subscription-coupons-list',
      },
      bhwName: `MerchantEmailSubscription:${merchantSlug}`,
      hydrated: true,
    });
  }

  return CouponTile({
    coupon: item,
    media,
    routes: pruneData(
      routes,
      'outlink:main',
      'redemption:main',
      'redemption:terms',
      'merchant:show'
    ),
    lazy: index >= AMOUNT_TO_PRELOAD,
  });
}

function getItems({
  related,
  coupons,
  merchantSlug,
  emailCTAExperiment,
  csrfToken,
}) {
  const items = [
    {
      type: 'email',
      merchantSlug,
      csrfToken,
      emailCTAExperiment,
    },
  ];

  if (related.parentCategory) {
    items.push({
      type: 'related',
      className: getRelatedTableClass(coupons, AMOUNT_BEFORE_INLINE_CONTENT),
      ...related,
    });
  }

  return [
    ...coupons.slice(0, AMOUNT_BEFORE_INLINE_CONTENT),
    ...items,
    ...coupons.slice(AMOUNT_BEFORE_INLINE_CONTENT),
  ];
}

function getListContent({
  coupons,
  routes,
  isTouch,
  media,
  related,
  merchantSlug,
  emailCTAExperiment,
  csrfToken,
}) {
  if (!coupons || !coupons.length) {
    if (related.parentCategory) {
      return renderItem({
        item: {
          type: 'related',
          ...related,
        },
        routes,
        isTouch,
      });
    }
  }

  const items = getItems({
    related,
    coupons,
    merchantSlug,
    emailCTAExperiment,
    csrfToken,
  });

  if (items.length === 1 && !emailCTAExperiment.treatment) {
    return null;
  }

  return h(
    'ul.coupons-list',
    items.map((item, index) =>
      h(
        'li.coupons-list-row',
        renderItem({ item, index, routes, media, isTouch })
      )
    )
  );
}

function CouponsList({
  premium = [],
  coupons,
  routes,
  isTouch,
  related = {},
  media = 'logo',
  showUberOffer,
  attrs = {},
  merchantSlug,
  emailCTAExperiment = {},
  csrfToken,
}) {
  return h(
    '',
    attrs,
    premium.map(coupon =>
      h(
        '.coupons-list-row',
        CouponUber({
          coupon,
          routes: pruneData(
            routes,
            'outlink:main',
            'redemption:main',
            'redemption:terms'
          ),
          showUberOffer,
        })
      )
    ),
    getListContent({
      coupons,
      routes,
      isTouch,
      media,
      related,
      merchantSlug,
      emailCTAExperiment,
      csrfToken,
    })
  );
}

module.exports = CouponsList;
